import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PermissionQueryCriteriaClass extends BaseCriteriaModel {
  namespace?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
}

export class PermissionCriteriaModelQuery {
  query = '';

  constructor(permissionCriteriaModel: PermissionQueryCriteriaClass) {

    if (!permissionCriteriaModel) {
      return;
    }

    this.query += permissionCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += permissionCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += permissionCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += permissionCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');

    this.query += '&status=' + permissionCriteriaModel.status;
    this.query += '&orderBy=' + permissionCriteriaModel.orderBy;
    this.query += '&order=' + permissionCriteriaModel.order;
    this.query += '&offset=' + permissionCriteriaModel.offset + '&limit=' + permissionCriteriaModel.limit;
  }
}
